import _Vue from 'vue' // <-- notice the changed import
import Helper from '../services/Helper.js'

// export type PluginFunction<T> = (Vue: typeof _Vue, options?: T) => void;
export function HelperPlugin(Vue: typeof _Vue, options?: any): void {
  Vue.prototype.$helper = Helper
}

